import React, { useEffect } from "react";
import "./Header.css";
import Button from "../UI/Button/Button";
import "../UI/Button/Button.css";
import phoneHeader from "../../assets/edificio.png";
import { BsMouse } from "react-icons/bs";

import AOS from "aos";
import "aos/dist/aos.css";

const Header = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);
  return (
    <section id="header">
      <div className="container header">
        <div className="header-left" data-aos="fade-right">
          <h1>
            <span>Innovación sin límites</span>
            <span>tecnología sin fronteras.</span>
            <span>Impulsa tu negocio.</span>
          </h1>
          <p className="u-text-small">
          Conectamos talento y tecnología para transformar negocios.
          A través de soluciones de software innovadoras y outsourcing especializado, 
          impulsamos el crecimiento y la eficiencia de nuestros clientes.
          </p>
          <div className="header-cta">
            <Button text={"Cóntactanos"} btnClass={"btn-dark"} href={"#subscribe"} />
            <Button text={"IT-personal"} btnClass={"btn-light"} href={"#download"} />
          </div>
        </div>
        <div className="header-right" data-aos="fade-left">
          <img src={phoneHeader} alt="phone" />
        </div>
      </div>
      <div className="floating-icon">
        <a href="#features">
          <BsMouse color="#00FF00" size={25} className="mouse" />
        </a>
      </div>
    </section>
  );
};

export default Header;
